<style>
	.flex-absolute {
		position: absolute;
		bottom: 21%;
		right: 17vw;
		z-index: 10;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	/* 	.u-img{
		width: 357px;
		height: 105px;
	} */

	.vue-img {
		width: 19vw;
		height: 11vh;
	}

	.sc-regular {
		width: 12vw;
		height: 63px;
		border-radius: 40px 40px 40px 40px;
		border: 1px solid #ffffff;
		margin-top: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 23px;
	}

	.sc-regular:hover {
		cursor: pointer;
	}

	.sr-only {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		white-space: nowrap;
		border: 0;
	}
</style>
<template>
	<div style="background-color: #fff">
		<h1 class="sr-only">京卡收 - 购物卡礼品卡回收正规平台</h1>
		<Hrader @refreshTheStatus="refreshTheStatus" ref="hreders" :idShwo="1" @skipCompents="landingClcik"></Hrader>
		<div>
			<div style="height: 70px"></div>
			<div class="assets-left">
				<img src="../assets/Home_slices1/Mask group@2x.png" style="width: 100%; height: auto" />
				<div class="flex-pos">
					<div class="flex-asstes">
						<div class="flex-home">
							<div><img src="../assets/Home_slices1/Group 1209@2x.png" style="width: 10px; height: 10px" /></div>
							<div class="flex-title">{{ marqueeCon[0] }}</div>
						</div>
						<div class="flex-home">
							<div><img src="../assets/Home_slices1/Group 1209@2x.png" style="width: 10px; height: 10px" /></div>
							<div class="flex-title">{{ marqueeCon[1] }}</div>
						</div>
						<div class="flex-home">
							<div><img src="../assets/Home_slices1/Group 1209@2x.png" style="width: 10px; height: 10px" /></div>
							<div class="flex-title">{{ marqueeCon[2] }}</div>
						</div>
					</div>
				</div>
				<div class="flex-absolute">
					<div>
						<!-- <img  src="../assets/HomeView/Group 1793@2x.png" class="u-img"/> -->
						<img src="../assets/HomeView/Group 1793@2x.png" class="vue-img" />
					</div>
					<div>
						<div class="flex-scalits">
							<div class="sc-regular" @click="JumpClickRef(1)">
								<img src="../assets/HomeView/Vector@2x (19).png" style="width: 27px; height: 27px" />
								<div class="assets-title">微信小程序</div>
							</div>
							<div class="sc-regular" @click="JumpClickRef(2)">
								<img src="../assets/HomeView/Android.png" style="width: 27px; height: 27px" />
								<div class="assets-title">安卓App下载</div>
							</div>
						</div>
						<div class="flex-scalits">
							<div class="sc-regular" @click="JumpClickRef(3)">
								<img src="../assets/HomeView/ios.png" style="width: 27px; height: 27px" />
								<div class="assets-title">苹果App下载</div>
							</div>
							<div class="sc-regular" style="background-color: #fff" @click="JumpClickRef(4)">
								<div class="assets-title" style="color: #ff2f17">我有卡要回收</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div style="background-color: #fff">
				<div class="rectangle" @click="viewClick">
					<div class="rectgle-flex"></div>
					<div class="flex-post">
						<div>
							<img src="../assets/Home_slices1/Group 1212@2x.png" style="width: 126px; height: 78px" />
						</div>
						<div>
							<div class="flex-assets">
								<div class="flex-text">
									结算
									<span class="time">{{ dataObj.pubTime }}</span>
								</div>
							</div>
							<div class="flex-title-text">{{ dataObj.content }}</div>
						</div>
					</div>
					<div class="flex-right">
						<div class="flex-title-views">查看</div>
						<div>
							<img src="../assets/Home_slices1/Group 1213@2x.png" style="width: 24px; height: 24px" />
						</div>
					</div>
				</div>

				<div class="home-slicess">
					<div class="slicess-padd">
						<div class="slicess-the-play" ref="scrollContainer">
							<div v-if="marListRef.length>8" class="assets-rectangle"
								:class="{ 'assets-rectangle1': indexNumber1 == 1 }" @click="reduction1">
								<img v-if="indexNumber1 != 1" src="../assets/Home_slices1/Rectangle 248@2x(1).png"
									style="width: 8px; height: 8px" />
								<img v-else src="../assets/Frame 1_slices/Rectangle 248@2x(3).png" style="width: 8px; height: 8px" />
							</div>
							<div v-else class="assets-rectangle" :class="{ 'assets-rectangle1': indexNumber1 == 1 }"
							style="background-color: transparent; border: none;">
							</div>
							<div style="width: 89%; margin-left: 12px; display: flex;">
								<div class="slicess-the-play1" v-show="index >= 8 * idsIndex1 && index < 8 * indexNumber1"
									v-for="(item, index) in marListRef" :key="index" @click="gasStation(index)">
									<div class="flex-the-play" :class="{ 'flex-the-play1': ids == index }">
										<img :src="item.coverImg"
											style="margin-top: 14px; wdith: 55px; height: 55px; border-radius: 55px;" />
										<div class="flex-then-title">{{ item.name }}</div>
									</div>
									<div class="bor-flex" v-if="marListRef.length - 1 != index"></div>
								</div>
							</div>
							<div v-if="marListRef.length>8" class="assets-rectangle"
								:class="{ 'assets-rectangle1': indexNumber1 * 8 >= marListRef.length }" @click="plus1">
								<img v-if="indexNumber1 * 8 < marListRef.length" src="../assets/Frame 1_slices/Rectangle 248@2x(1).png"
									style="width: 8px; height: 8px" />
								<img v-else src="../assets/Home_slices1/Rectangle 248@2x.png" style="width: 8px; height: 8px" />
							</div>
						</div>

						<div class="flex-assets-rectangle">
							<div class="assets-rectangle" :class="{ 'assets-rectangle1': indexNumber == 1 }" @click="reduction">
								<img v-if="indexNumber != 1" src="../assets/Home_slices1/Rectangle 248@2x(1).png"
									style="width: 8px; height: 8px" />
								<img v-else src="../assets/Frame 1_slices/Rectangle 248@2x(3).png" style="width: 8px; height: 8px" />
							</div>
							<div class="collecting-min">
								<div class="collecting-width" v-for="(item, index) in dataListSkip" @click="routeClick(item)"
									:key="index" v-show="index >= 10 * idsIndex && index < 10 * indexNumber">
									<div class="colcting-rectang">
										<img :src="item.coverImg" class="card-cover-img" :alt="item.name" />
									</div>
									<div style="height: 10px"></div>
									<div class="Shopping-card">{{ item.name }}</div>
									<div class="shoppg-group" v-if="item.details">
										<span v-if="item.details[0].rate">{{ item.details[0].rate }}</span>
										<span v-if="item.details[0].rate" style="font-size: 11px">折</span>
										<span v-else style="color: #fff">折</span>
									</div>
									<div class="rectangle-group">我有卡要回收</div>
								</div>
							</div>
							<div class="assets-rectangle" :class="{ 'assets-rectangle1': indexNumber * 10 >= dataListSkip.length }"
								@click="plus">
								<img v-if="indexNumber * 10 < dataListSkip.length"
									src="../assets/Frame 1_slices/Rectangle 248@2x(1).png" style="width: 8px; height: 8px" />
								<img v-else src="../assets/Home_slices1/Rectangle 248@2x.png" style="width: 8px; height: 8px" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="platform">
				<div style="height: 37px"></div>
				<div class="platfor-image">
					<div style="padding-top: 27px; margin-left: 8px">
						平台
						<span style="color: #ff3333">优势</span>
					</div>
				</div>
				<div class="platfor-title">充值卡券回收正规平台，30秒极速回收</div>
				<div class="list-width">
					<div class="list-flex">
						<img src="../assets/HomeView/Group 1783@2x.png" style="width: 110px; height: 110px" />
						<div class="title-width">丰富</div>
						<div class="text-width">支持300+品牌卡券回收</div>
					</div>
					<div class="list-flex">
						<img src="../assets/HomeView/Group 1782@2x.png" style="width: 110px; height: 110px" />
						<div class="title-width">高价</div>
						<div class="text-width">高价回收各类卡券</div>
					</div>
					<div class="list-flex">
						<img src="../assets/HomeView/Group 1781@2x.png" style="width: 110px; height: 110px" />
						<div class="title-width">极速</div>
						<div class="text-width">秒回收您的卡券</div>
					</div>
					<div class="list-flex">
						<img src="../assets/HomeView/Group 1780@2x.png" style="width: 110px; height: 110px" />
						<div class="title-width">便捷</div>
						<div class="text-width">减少回收流程便捷回收</div>
					</div>
					<div class="list-flex">
						<img src="../assets/HomeView/Group 1779@2x.png" style="width: 110px; height: 110px" />
						<div class="title-width">安全</div>
						<div class="text-width">加密回收 - 保障安全</div>
					</div>
				</div>
			</div>

			<div class="popular">
				<div class="platfor-image">
					<div style="padding-top: 27px; margin-left: 8px">
						<span style="color: #ff3333">热门</span>
						回收
					</div>
				</div>
				<div class="popular-text">让沉睡的购物卡，变成你的零花钱！</div>
			</div>
			<div style="display: flex; justify-content: center">
				<div class="Hot-card">
					<div class="collecting-min-hot">
						<div class="collecting-width-hot" v-for="item in dataList" @click="popularServices(item)">
							<div class="colcting-rectang">
								<img v-if="item !== 1" :src="item.coverImg" class="card-cover-img" :alt="item.name" />
							</div>

							<div class="Shopping-card">{{ item.name }}</div>
							<div class="shoppg-group">
								{{ item.hotDes }}
							</div>
							<div class="rectangle-group" style="background: #fff; border: 1px solid #ff2f17; color: #ff2f17">我有卡要回收
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="more" style="margin-top: 60px;">
				<div class="view-more" @click="viewMore">查看更多</div>
			</div>

			<div class="platform-more">
				<div style="height: 37px"></div>
				<div class="platfor-image" style="width: 198px; height: 71px">
					<div style="padding-top: 35px; margin-left: 12px; font-size: 22px">
						京卡收
						<span style="color: #ff3333">帮助动态</span>
					</div>
				</div>
				<div class="platfor-title">充值卡券回收正规平台，30秒极速回收</div>
				<div class="more-width" style="display: flex; background: transparent">
					<div class="list-const">
						<div class="list-bacgrand">
							<div class="list-right-asstes">
								<div class="flex-asstes-left">
									<div>
										<img src="../assets/HomeView/Vector@2x (21).png" style="width: 14px; height: 16px" />
									</div>
									<div class="list-title">常见问题</div>
								</div>
								<div class="flex-asstes-left-group" @click="Jump">
									<div class="list-text">查看更多</div>
									<div>
										<img src="../assets/HomeView/Group 1718@2x.png" style="width: 18px; height: 18px" />
									</div>
								</div>
							</div>
							<div class="border-botton"></div>
							<div class="flex-pingFang" v-for="(item, index) in dataListTitle" @click="JumpList(item)"
								v-show="index<6">
								<div class="flex-homeView">
									<div class="flex-red-dot">
										<div class="red-dot"></div>
										<div class="titel-red-dot">{{ item.question }}</div>
									</div>
									<div class="date-homeView">{{ item.updateTime }}</div>
								</div>
								<div class="border-botton" v-if="index != 5"></div>
							</div>
						</div>
					</div>

					<div class="list-const" style="margin-left: 20px">
						<div class="list-bacgrand">
							<div class="list-right-asstes">
								<div class="flex-asstes-left">
									<div>
										<img src="../assets/HomeView/Group 1719@2x.png" style="width: 14px; height: 16px" />
									</div>
									<div class="list-title">最新动态</div>
								</div>
							</div>
							<div class="border-botton"></div>
							<div class="flex-pingFang" v-for="(item, index) in marqueeCon" v-show="index<6">
								<div class="flex-homeView1">
									<div class="flex-red-dot">
										<div class="red-dot"></div>
										<div class="titel-red-dot1" style="width: 550px;">{{ item }}</div>
									</div>
								</div>
								<div class="border-botton" v-if="index != 5"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="more">
					<div class="view-more" @click="Jump">查看更多</div>
				</div>
			</div>

			<div class="more-width">
				<div class="platfor-image">
					<div style="padding-top: 30px; margin-left: 13px; font-size: 22px">回收流程</div>
				</div>
				<div class="more-text">选择京卡收 安全有保障</div>
				<div class="flex-more">
					<div>
						<img src="../assets/login-account/Group 951@2x.png" class="images" />
					</div>
					<div class="hot-group">
						<div class="hot-slices"></div>
						<div>完成实名认证</div>
					</div>
					<div>
						<img src="../assets/login-account/Group 951@2x(1).png" class="images" />
					</div>
					<div class="hot-group">
						<div class="hot-slices"></div>
						<div>等待平台认证</div>
					</div>
					<div>
						<img src="../assets/login-account/Group 951@2x(2).png" class="images" />
					</div>
					<div class="hot-group">
						<div class="hot-slices"></div>
						<div>相应资金到账</div>
					</div>
					<div>
						<img src="../assets/login-account/Group 1214@2x.png" class="images" />
					</div>
					<div class="hot-group">
						<div class="hot-slices"></div>
						<div>绑定提现账号</div>
					</div>
					<div>
						<img src="../assets/login-account/Group 1215@2x.png" class="images" />
					</div>
					<div class="hot-group">
						<div class="hot-slices"></div>
						<div>银行或支付宝</div>
					</div>
					<div>
						<img src="../assets/login-account/Group 951@2x(3).png" class="images" />
					</div>
				</div>
			</div>
			<Tabr></Tabr>
			<div>
				<Customer></Customer>
			</div>
		</div>
		<el-dialog v-model="dialogVisible" width="400" :before-close="handleClose">
			<span>
				<div style="display: flex; align-items: center; justify-content: center;">
					<img v-if="idstRef==1" src="../assets/Home_slices1/WechatIMG198.png" style="width: 300px; height: 300px;" />
					<img v-if="idstRef==2 || idstRef==3" src="../assets/HomeView/bitHovieat.jpg"
						style="width: 300px; height: 300px;" />
				</div>
			</span>
			<template #footer></template>
		</el-dialog>
	</div>
</template>

<script setup>
	import {
		ref,
		onMounted
	} from 'vue';
	import {
		useRouter,
		useRoute
	} from 'vue-router';
	import Tabr from '@/components/tabrButton.vue';
	import Customer from '@/components/customer.vue';
	import Hrader from '@/components/header.vue';
	import {
		cardHots,
		noticePub,
		categoryList,
		cardList,
		appApiCardListQa
	} from '@/utils/api.js';
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus';
	import BigNumber from 'bignumber.js';
	import dayjs from 'dayjs';
	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue';
	import 'swiper/swiper-bundle.css';
	const dialogVisible = ref(false);

	let ids = ref(0);
	let router = useRouter();
	let dataList = ref([]);
	let dataObj = ref({});
	let marqueeCon = ref('');
	let information = ref({});
	let marListRef = ref([]);
	let dataListSkip = ref([]);
	let idsIndex = ref(0);
	let indexNumber = ref(0);
	let dataListTitle = ref([]);
	const skipClick = (item) => {
		router.push({
			path: item
		});
	};
	const info = async () => {
		const res = await cardHots();
		dataList.value = res.data;
		const ref = await noticePub();
		dataObj.value = ref.data;
		if (dataObj.value.pubTime) {
			dataObj.value.pubTime = dayjs(dataObj.value.pubTime).format('YYYY/MM/DD');
		}
		initMarquee();
	};
	const into = async () => {
		let res = await categoryList();
		marListRef.value = res.data;
		cardListInfo();
	};
	const viewClick = () => {
		console.log(11111);
		router.push({
			path: '/dynamics'
		});
		console.log(11111);
	};
	const gasStation = (index) => {
		ids.value = index;
		cardListInfo();
	};

	const Jump = () => {
		router.push({
			path: '/dynamics',
			query: {
				id: 2
			}
		});
	};

	const JumpList = (item) => {
		router.push({
			path: '/dynamics',
			query: {
				id: 2,
				ids: item.id
			}
		});
	};

	const infoSever = async () => {
		let ref = await appApiCardListQa();
		dataListTitle.value = ref.data;
		dataListTitle.value.forEach((item) => {
			item.updateTime = dayjs(item.updateTime).format('YYYY年MM月DD日');
		});
	};

	async function initMarquee() {
		let marqueeConTmp = '';
		for (let i = 0; i < 10; i++) {
			let d = Math.ceil(Math.random() * 10);
			let c = Math.ceil(Math.random() * dataList.value.length);
			if (d == 0 || c < 0 || c >= dataList.value.length) {
				continue;
			}
			try {
				marqueeConTmp += dayjs().subtract(d, 'day').format('MM月DD日') + '用户' + (d + 832) + '回收成功¥' + (c + 1) * 100 +
					dataList.value[c].name + '\n';
			} catch (e) {
				console.log(e);
			}
		}
		marqueeCon.value = marqueeConTmp.split('\n');
		console.log(1111, marqueeCon.value);
	}
	const viewMore = () => {
		if (!information.value) {
			router.push({
				path: '/login'
			});
			return false;
		}
		router.push({
			path: '/cardVoucher'
		});
	};
	const reduction = () => {
		if (indexNumber.value == 1) return false;
		indexNumber.value--;
		idsIndex.value--;
	};
	let idsIndex1 = ref(0);
	let indexNumber1 = ref(1);
	const reduction1 = () => {
		if (indexNumber1.value == 1) return false;
		indexNumber1.value--;
		idsIndex1.value--;
	};
	const plus = () => {
		if (indexNumber.value * 10 < dataListSkip.value.length) {
			indexNumber.value++;
			idsIndex.value++;
		}
	};
	const plus1 = () => {
		if (indexNumber1.value * 8 < marListRef.value.length) {
			indexNumber1.value++;
			idsIndex1.value++;
		}
	};
	const cardListInfo = async () => {
		idsIndex.value = 0;
		indexNumber.value = 1;
		let ref = await cardList({
			categoryId: marListRef.value[ids.value].id,
			userId: information.value?.userId
		});
		ref.data?.forEach((e) => {
			e.details?.forEach((item, index) => {
				if (item.recycleType === 'rate') {
					let oRate = new BigNumber(item.price).dividedBy(100);
					let rate = '';
					if (item.channelCode == 'zheka') {
						rate = new BigNumber(item.zhekaRate).plus(oRate);
					} else {
						rate = new BigNumber(item.recycleRate).plus(oRate);
						// rate = new BigNumber(item.recycleRate);
					}
					if (item.vipRate) {
						rate = new BigNumber(item.vipRate);
					}
					if (rate.comparedTo(1) === 1) {
						rate = new BigNumber(1);
					}
					item.price = new BigNumber(item.name).multipliedBy(rate).toFixed(4);
					item.rate = new BigNumber(rate).times(100).toFixed(2);
				} else if (item.recycleType === 'raterang') {
					let oRate = new BigNumber(item.price).dividedBy(100);
					let rate = new BigNumber(item.minRecycleRate).plus(oRate);
					if (rate.comparedTo(1) === 1) {
						rate = new BigNumber(1);
					}
					item.price = new BigNumber(item.name).multipliedBy(rate).toFixed(4);
					item.rate = new BigNumber(rate).times(100).toFixed(2);
				} else if (item.recycleType === 'fixed') {
					let rate = new BigNumber(item.price).plus(oRate);
					item.rate = new BigNumber(rate).times(100).toFixed(2);
				}
			});
		});
		ref.data?.forEach((e) => {
			e.details?.forEach((item, index) => {
				if (item.recycleType === 'customfacevalue' || item.type === 2) {
					e.details.splice(index, 1);
				}
			});
		});
		console.log(ref.data);
		dataListSkip.value = ref.data;
	};
	let hreders = ref('');
	const popularServices = (item) => {
		if (!information.value) {
			router.push({
				path: '/login'
			});
			return false;
		}
		router.push({
			path: '/cardVoucher',
			query: {
				ids: item.id,
				categoryId: item.categoryId
			}
		});
	};
	const routeClick = (item) => {
		if (!information.value) {
			router.push({
				path: '/login'
			});
			return false;
		}
		router.push({
			path: '/cardVoucher',
			query: {
				ids: item.id,
				categoryId: item.categoryId
			}
		});
	};
	const refreshTheStatus = (res) => {
		let infomation = localStorage.getItem('information');
		information.value = JSON.parse(infomation);
	};

	let idstRef = ref(1);
	const JumpClickRef = (item) => {
		if (item == 4) {
			viewMore();
			return false;
		}
		idstRef.value = item;
		dialogVisible.value = true;
	}

	let scrollContainer = ref(null);

	let route = useRoute();
	onMounted(() => {
		let infomation = localStorage.getItem('information');
		information.value = JSON.parse(infomation);
		info();
		into();
		infoSever();

		let isDown = false;
		let startX, scrollLeft;

		scrollContainer.value.addEventListener('mousedown', (e) => {
			isDown = true;
			startX = e.pageX - scrollContainer.value.offsetLeft;
			scrollLeft = scrollContainer.value.scrollLeft;
		});

		scrollContainer.value.addEventListener('mouseleave', () => {
			isDown = false;
		});

		scrollContainer.value.addEventListener('mouseup', () => {
			isDown = false;
		});

		scrollContainer.value.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX - scrollContainer.value.offsetLeft;
			const walk = (x - startX) * 3; // 调整速度和灵敏度
			scrollContainer.value.scrollLeft = scrollLeft - walk;
		});

	});
</script>
<style lang="scss" scoped>
	.head-guidance {
		width: 100%;
		height: 70px;
		background: #ffffff;
		border-radius: 0px 0px 0px 0px;
		position: fixed;
		top: 0;
		z-index: 111;

		.head-guidance-flex {
			width: 100%;
			display: flex;
			justify-content: space-between;

			.image {
				width: 106px;
				height: 40px;
				margin-top: 15px;
				margin-left: 160px;
			}
		}

		.head-right {
			display: flex;
			margin-right: 104px;

			.head-right-flex {
				display: flex;
				align-items: center;
				margin-top: 12px;
				margin-left: 36px;

				.home-right {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
					text-align: left;
					font-style: normal;
					text-transform: none;
					margin-left: 6px;
				}
			}

			.head-right-flex:hover {
				cursor: pointer;
			}

			.head-right-flex1:hover {
				cursor: pointer;
			}

			.head-right-flex1 {
				display: flex;
				align-items: center;
				padding: 11px 16px;
				background: #ff3333;
				border-radius: 74px 74px 74px 74px;
				margin-top: 13px;

				.home-right {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: #fff;
					text-align: left;
					font-style: normal;
					text-transform: none;
					margin-left: 6px;
				}
			}

			.frame-flex {
				height: 18px;
				border-right: 1px solid #dddddd;
				margin-top: 26px;
				margin-left: 22px;
				padding-right: 44px;
			}
		}
	}

	.assets-left {
		position: relative;
		width: 100%;
		z-index: 1;
		height: auto;
	}

	.flex-pos {
		display: flex;
		align-items: center;
		justify-content: space-around;
		position: absolute;
		top: 0px;
		width: 100%;
		height: 38px;
		background: #9c0d1e;
		border-radius: 0px 0px 0px 0px;
	}

	.flex-asstes {
		width: 1280px;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.flex-top1 {
		margin-right: 32vw;
		width: 189px;
		height: 196px;
		// width: 15vw;
		// height:30vh;
		background: url('@/assets/HomeView/Group 1775@2x.png') no-repeat;
		background-size: cover;
	}

	.flex-home {
		display: flex;
		white-space: nowrap;

		.flex-title {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			font-style: normal;
			text-transform: none;
			margin-left: 16px;
			margin-top: 2px;
			white-space: nowrap;
		}
	}

	.rectangle {
		width: 1280px;
		height: 78px;
		background: linear-gradient(180deg, #ffffff 0%, #fffefe 100%);
		box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.03);
		border-radius: 8px 8px 8px 8px;
		margin: 0 auto;
		margin-top: -37px;
		position: relative;
		z-index: 1;

		.rectgle-flex {
			width: 100%;
			height: 34px;
			// background: rgba(255, 234, 234, 0.5);
			border-radius: 8px 8px 8px 8px;
			position: absolute;
			top: 0;
			z-index: -1;
		}
	}

	.flex-post {
		display: flex;
	}

	.flex-title-text {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		margin-left: 35px;
		font-style: normal;
		text-transform: none;
		margin-top: 2px;
		width: 47vw;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.flex-assets {
		margin-left: 35px;
		margin-top: 13px;

		.flex-text {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 16px;
			font-style: normal;
			text-transform: none;
		}

		.time {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #333333;
			font-style: normal;
			text-transform: none;
		}
	}

	.flex-right {
		position: absolute;
		display: flex;
		align-items: center;
		right: 24px;
		top: 31%;
	}

	.flex-title-views {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ff2f17;
		font-style: normal;
		text-transform: none;
		margin-top: -6px;
		margin-right: 10px;
	}

	.home-slicess {
		width: 1280px;
		background: rgba(255, 255, 255, 1);
		border-radius: 8px 8px 8px 8px;
		margin: 0 auto;
		margin-top: 31px;

		.slicess-padd {
			padding: 35px;
			padding-top: 32px;
			padding-bottom: 55px;

			.slicess-the-play {
				// margin: auto;
				display: flex;
				align-items: center;
				// justify-content: center;
				width: 1280px;
				overflow: hidden;
				overflow-x: scroll;

				.slicess-the-play1 {
					width: 143px;
					// align-items: center;
					// justify-content: center;
				}
			}

			.slicess-the-play:hover {
				cursor: pointer;
			}
		}
	}

	.slicess-the-play::-webkit-scrollbar {
		display: none;
	}

	.Hot-card {
		width: 1280px;
	}

	.bor-flex {
		height: 26px;
		// border-left: 1px solid #eeeeee;
		margin-left: 16px;
		padding-right: 16px;
	}

	.flex-the-play {
		display: flex;
		align-items: center;
		flex-direction: column;
		width: 115px;
		height: 133px;
		margin-left: 10px;
		background: url('../assets/homeVierGroup/notSelected.png') no-repeat;
		background-size: cover;
	}

	.flex-then-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 18px;
		font-style: normal;
		text-transform: none;
		margin-top: 22px;
	}

	.flex-the-play1 {
		background: url('../assets/homeVierGroup/selected.png') no-repeat;
		background-size: cover;

		.flex-then-title {
			color: #fff;
		}
	}

	.flex-assets-rectangle {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}

	.assets-rectangle {
		width: 29px;
		height: 46px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #eeeeee;
		line-height: 46px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.assets-rectangle:hover {
		cursor: pointer;
	}

	.collecting-min {
		width: 100%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		overflow: hidden;
	}

	.collecting-width {
		background: #ffffff;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #eeeeee;
		width: calc(20% - 29px);
		margin-left: 24px;
		margin-top: 32px;
		padding: 0 7px 18px;
		box-sizing: border-box;
	}

	.Shopping-card {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-top: 9px;
		padding-bottom: 5px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.shoppg-group {
		font-family: DIN Alternate, DIN Alternate;
		font-weight: bold;
		font-size: 16px;
		color: #ff2f17;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}

	.rectangle-group {
		width: 105px;
		height: 29px;
		background: linear-gradient(270deg, #ff3333 0%, #ff7433 100%);
		border-radius: 20px 20px 20px 20px;

		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 12px;
		color: #ffffff;
		line-height: 29px;
		text-align: center;
		font-style: normal;
		text-transform: none;

		margin: auto;
		margin-top: 10px;
	}

	.rectangle-group:hover {
		cursor: pointer;
	}

	.popular {
		margin-top: 50px;
		padding-bottom: 3px;
		display: flex;
		align-items: center;
		flex-direction: column;
		width: 100%;
	}

	.popular-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 22px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}

	.popular-text {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-top: 6px;
		font-style: normal;
		text-transform: none;
	}

	.collecting-min-hot {
		width: 100%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		overflow: hidden;
	}

	.collecting-width-hot {
		background: #ffffff;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #eeeeee;
		width: 187px;
		margin-left: 26px;
		margin-top: 13px;
		padding: 0 7px 18px;
		box-sizing: border-box;
	}

	.collecting-width-hot:hover {
		transform: translateY(-1px) scale(1.05);
		/* 向上移动并放大 */
	}

	.view-more {
		width: 162px;
		height: 42px;
		background: #ff2f17;
		border-radius: 4px 4px 4px 4px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		line-height: 42px;
		letter-spacing: 2px;
		text-align: center;
		font-style: normal;
		margin-top: -40px;
		text-transform: none;
	}

	.view-more:hover {
		cursor: pointer;
	}

	.more {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 37px;
	}

	.more-width {
		width: 1280px;
		padding-top: 41px;
		padding-bottom: 45px;
		background: #ffffff;
		border-radius: 8px 8px 8px 8px;
		margin: auto;
		margin-top: 50px;
	}

	.more-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 22px;
		color: #333333;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}

	.flex-more {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-left: 44px;
		margin-top: 30px;
	}

	.more-text {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		text-align: center;
		font-style: normal;
		margin-top: 6px;
		text-transform: none;
	}

	.hot-group {
		white-space: nowrap;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #000000;
		font-style: normal;
		text-transform: none;
		padding-bottom: 7px;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-left: -10px;
	}

	.hot-slices {
		margin: auto;
		width: 50px;
		height: 0px;
		border-top: 2px solid #eeeeee;
		padding-top: 10px;
	}

	.images {
		width: 85%;
		height: auto;
	}

	.flex-right {
		display: flex;
	}

	.userName {
		width: 65px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		line-height: 16px;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-left: 7px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.arrowDown {
		width: 12px;
		height: 12px;
		background: #eeeeee;
		border-radius: 40px;
		border: 1px solid #eeeeee;
		line-height: 12px;
		text-align: center;
	}

	.center {
		position: relative;
		width: 116px;
		height: 94px;
		background: rgba(51, 51, 51, 0.9);
		border-radius: 0px 0px 0px 0px;
		margin-left: auto;
		margin-right: 100px;
		margin-top: 25px;
	}

	.center:hover {
		cursor: pointer;
	}

	.triangular {
		width: 0;
		height: 0;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-bottom: 10px solid rgba(51, 51, 51, 0.9);
		position: absolute;
		top: -10px;
		right: 10px;
		white-space: nowrap;
	}

	.bor-top {
		width: 96px;
		height: 0px;
		border: 1px solid #5e5555;
		margin-left: 10px;
	}

	.title-tranglar {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		text-align: center;
		font-style: normal;
		text-transform: none;
		padding: 12px 0px;
	}

	.assets-rectangle {
		background-color: #ff3333;
		position: relative;
		z-index: 99;
	}

	.assets-rectangle1 {
		background-color: #eeeeee;
	}

	.flex-scalits {
		display: flex;
		margin-left: -23px;
	}

	.assets-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 20px;
		color: #ffffff;
		margin-left: 6px;
		font-style: normal;
		text-transform: none;
	}

	.colcting-rectang {
		width: 100%;
		aspect-ratio: 85.6 / 54;
		height: auto;
		border-radius: 8px;
		border: 1px solid #eeeeee;
		margin-top: 10px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #f5f5f5;
		box-sizing: border-box;
	}

	.card-cover-img {
		width: 100%;
		height: 100%;
		object-fit: contain;
		display: block;
		border-radius: 6px;
	}

	.platform {
		height: 458px;
		background: #fff8f6;
		border-radius: 0px 0px 0px 0px;
		margin-top: -30px;
	}

	.platform-more {
		padding-bottom: 40px;
		background: #fff8f6;
		border-radius: 0px 0px 0px 0px;
		margin-top: 79px;
	}

	.platfor-image {
		background: url('../assets/HomeView/Group 1784@2x.png') no-repeat;
		background-size: cover;
		width: 143px;
		height: 71px;
		margin: auto;
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 26px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}

	.platfor-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}

	.list-width {
		width: 1280px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		margin-top: 70px;
	}

	.list-flex {
		display: flex;
		flex-direction: column;
		align-items: center;

		.title-width {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 20px;
			color: #222222;
			font-style: normal;
			text-transform: none;
			margin-top: 28px;
		}

		.text-width {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: rgba(34, 34, 34, 0.7);
			text-align: left;
			font-style: normal;
			text-transform: none;
			margin-top: 4px;
		}
	}

	.list-const {
		width: 630px;
		background: #ffffff;
		border-radius: 8px 8px 8px 8px;
	}

	.list-bacgrand {
		padding: 22px;
	}

	.list-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-top: -4px;
		margin-left: 7px;
	}

	.list-text {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ff2f17;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-top: -4px;
		margin-right: 8px;
	}

	.flex-asstes-left {
		display: flex;
		align-items: center;
	}

	.flex-asstes-left-group {
		display: flex;
		align-items: center;
	}

	.flex-asstes-left-group:hover {
		cursor: pointer;
	}

	.list-right-asstes {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.border-botton {
		width: 586px;
		height: 0px;
		border-top: 1px solid #eeeeee;
		margin-top: 12px;
		padding-top: 16px;
	}

	.red-dot {
		width: 5px;
		height: 5px;
		background: #ff3333;
		border-radius: 0px 0px 0px 0px;
	}

	.flex-homeView {
		display: flex;
		justify-content: space-between;
	}

	.flex-homeView:hover {
		cursor: pointer;
	}

	.date-homeView {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 17px;
		color: #aaaaaa;
		font-style: normal;
		text-transform: none;
	}

	.flex-red-dot {
		display: flex;
		align-items: center;
	}

	.titel-red-dot {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
		margin-left: 13px;
		font-style: normal;
		text-transform: none;
	}

	.titel-red-dot1 {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
		margin-left: 13px;
		font-style: normal;
		text-transform: none;
	}

	.titel-red-dot:hover {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 18px;
		color: #ff3333;
		font-style: normal;
		text-transform: none;
		cursor: pointer;
	}
</style>